@if (positionTooltip === 'topCenter') {
  <div [class.actions]="actions" [class.inside-table]="insideTable" class="top-center">
    <div class="top-center__content {{ textAlign }}">
      {{ tooltipText }}
    </div>
  </div>
}

@if (positionTooltip === 'topRight') {
  <div [class.actions]="actions" [class.inside-table]="insideTable" class="top-right">
    <div class="top-right__content {{ textAlign }}">
      {{ tooltipText }}
    </div>
  </div>
}

@if (positionTooltip === 'topLeft') {
  <div [class.actions]="actions" [class.inside-table]="insideTable" class="top-left">
    <div class="top-left__content {{ textAlign }}">
      {{ tooltipText }}
    </div>
  </div>
}

@if (positionTooltip === 'bottomCenter') {
  @if (patientSignerSaved) {
    <div
      [class.actions]="actions"
      [class.inside-table]="insideTable"
      [class.representative-tooltip]="!!patientSignerSaved"
      class="bottom-center">
      <div class="bottom-center__content">
        @if (patientSignerSaved?.relationshipTitle) {
          <div class="representative-row">
            <strong>Relationship:</strong> {{ patientSignerSaved?.relationshipTitle ?? '' }};
          </div>
        }
        @if (patientSignerSaved?.fullName) {
          <div class="representative-row">
            <strong>Full name:</strong> {{ patientSignerSaved?.fullName ?? '' }};
          </div>
        }
        @if (patientSignerSaved?.reason) {
          <div class="representative-row">
            <strong>Reason:</strong> {{ patientSignerSaved?.reason ?? '' }}{{ patientSignerSaved?.relationshipToRecipient ? ';' : '' }}
          </div>
        }
        @if (patientSignerSaved?.relationshipToRecipient) {
          <div class="representative-row">
            <strong>Relationship:</strong> {{ patientSignerSaved?.relationshipToRecipient ?? '' }}
          </div>
        }
      </div>
    </div>
  } @else {
    <div
      [class.actions]="actions"
      [class.inside-table]="insideTable"
      class="bottom-center">
      <div class="bottom-center__content {{ textAlign }}">
        {{ tooltipText }}
      </div>
    </div>
  }
}
